// @flow

import React from 'react';
import { Text, Icon, Col } from '../';
import TabTitleWrapper from './TabTitleWrapper';

type Props = {
  iconName: String,
  iconSize?: Number,
  text: String,
  active: Number,
  onClick: Function,
  color: String,
  disabled?: Boolean,
};

export default function TabTitle({
  iconName,
  iconSize = 22,
  text,
  active,
  onClick,
  color,
  disabled,
}: Props) {
  let activeColor = active ? 'white' : 'secondary';
  if (color) {
    activeColor = color;
  }
  return (
    <Col className="px-1">
      <TabTitleWrapper
        className={`py-2 py-md-0 ${disabled ? 'not-allowed' : 'pointer'}`}
        onClick={onClick}
        isActive={active}
      >
        {iconName ? (
          <Icon
            color={activeColor}
            className="px-1"
            name={iconName}
            size={iconSize}
          />
        ) : null}
        <Text className="px-1" color={activeColor} size="pxlg">
          {text}
        </Text>
      </TabTitleWrapper>
    </Col>
  );
}
